import { render, staticRenderFns } from "./OnetoOneForm.vue?vue&type=template&id=40e5ca07&scoped=true"
import script from "./OnetoOneForm.vue?vue&type=script&lang=js"
export * from "./OnetoOneForm.vue?vue&type=script&lang=js"
import style0 from "./OnetoOneForm.vue?vue&type=style&index=0&id=40e5ca07&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e5ca07",
  null
  
)

export default component.exports